var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.linksToDisplay)?_c('div',_vm._l((_vm.linksToDisplay),function(link){return _c('a',{key:link.name,staticClass:"banner-link",attrs:{"href":link.linkUrl,"title":link.hoverText || link.name,"target":"_blank"}},[_c('img',{staticClass:"image-link",attrs:{"src":link.image}})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }